import React from 'react';
import PropTypes from 'prop-types';

/**
 * Card3D - A modern card component (hover effect removed)
 */
const Card3D = ({
  children,
  className = '',
  bgColor = 'bg-white',
  textColor = 'text-gray-800',
  borderRadius = 'rounded-xl',
  shadow = 'shadow-xl',
  border = false,
  borderColor = 'border-gray-200',
  height = 'auto',
  width = 'auto',
  ...props
}) => {
  // Enhanced 3D style with shadow
  const cardStyle = {
    height,
    width,
    boxShadow: '3px 3px 0 rgba(0, 0, 0, 0.8)',
    transform: 'translateX(-3px) translateY(-3px)'
  };

  return (
    <div
      className={`${bgColor} ${textColor} ${borderRadius} ${border ? `border ${borderColor}` : ''} overflow-hidden ${className}`}
      style={cardStyle}
      {...props}
    >
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );

};

Card3D.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  borderRadius: PropTypes.string,
  shadow: PropTypes.string,
  border: PropTypes.bool,
  borderColor: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])};

export default Card3D;
